import Vue from 'vue'
import App from './App.vue'
import router from './router'
import permission from './directive/permission'

// 引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import wsManager from '@/utils/websocket'

// 全局WebSocket状态管理
let isAppClosing = false

window.addEventListener('beforeunload', () => {
  isAppClosing = true
  wsManager.logout()
})

// import {Pagination,Dialog,Dropdown,DropdownMenu,DropdownItem,Menu,Submenu,MenuItem,MenuItemGroup,Input,Button,Table,
//   TableColumn,DatePicker,Select,Option,Form,FormItem,Message,MessageBox} from 'element-ui'

import './assets/icons' // icon
import './styles/stockLevel.scss'
import './styles/message.scss'

Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'small' })
Vue.use(permission)

import {MessageBox, Loading} from 'element-ui'
import message from '@/utils/message'
// 挂载Message和MessageBox
Vue.prototype.$message = message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$loading = Loading.service
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
